(() => {
  if (window.__asperariaFacetsMobileInit) return;
  window.__asperariaFacetsMobileInit = true;

  let clearing = false;
  const isMobile = () => window.matchMedia("(max-width: 699px)").matches;
  const isV2Form = (form) => Boolean(form?.closest("facets-form")?.hasAttribute("data-asp-filter-v2"));

  const clearOtherFilters = (form, keep) => {
    clearing = true;
    form.querySelectorAll('input[name^="filter."], select[name^="filter."]').forEach((el) => {
      if (el === keep) return;

      if (el.type === "checkbox" || el.type === "radio") {
        if (el.checked) el.checked = false;
        return;
      }

      if (el.name.includes("filter.v.price")) {
        if (el.type === "range") {
          if (el === el.parentElement?.querySelector('input[type="range"]:first-child')) {
            el.value = el.min;
          } else {
            el.value = el.max;
          }
          return;
        }
        el.value = "";
      }
    });
    clearing = false;
  };

  document.addEventListener(
    "change",
    (event) => {
      if (clearing) return;

      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (!target.name || !target.name.includes("filter.")) return;

      const form = target.closest("form.facets") || target.closest("facets-form")?.querySelector("form.facets");
      if (!form) return;

      if (!isV2Form(form)) return;

      const isActivating =
        target.type === "checkbox" || target.type === "radio" ? target.checked : true;

      if (isActivating) {
        clearOtherFilters(form, target);
      }

      if (!isMobile()) return;
      if (target.name.includes("filter.v.price")) return;

      const drawer = target.closest("facets-drawer");
      if (drawer?.open && typeof drawer.hide === "function") {
        drawer.hide();
      }
    },
    true
  );

  document.addEventListener("click", (event) => {
    const apply = event.target.closest(".facets-drawer__apply");
    if (!apply) return;
    const drawer = apply.closest("facets-drawer");
    if (drawer?.open && typeof drawer.hide === "function") {
      drawer.hide();
    }
  });

  const bindSwipe = (drawer) => {
    if (!drawer || drawer.dataset.aspSwipeBound === "1") return;
    drawer.dataset.aspSwipeBound = "1";

    let startX = 0;
    let startY = 0;
    let tracking = false;

    drawer.addEventListener(
      "touchstart",
      (event) => {
        if (!drawer.open) return;
        const touch = event.changedTouches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        tracking = true;
      },
      { passive: true }
    );

    drawer.addEventListener(
      "touchmove",
      (event) => {
        if (!tracking || !drawer.open) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        if (dx > 12 && Math.abs(dx) > Math.abs(dy)) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    drawer.addEventListener(
      "touchend",
      (event) => {
        if (!tracking || !drawer.open) return;
        tracking = false;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        if (dx > 60 && Math.abs(dy) < 50 && typeof drawer.hide === "function") {
          drawer.hide();
        }
      },
      { passive: true }
    );
  };

  let edgeStartX = 0;
  let edgeStartY = 0;
  let edgeTracking = false;

  document.addEventListener(
    "touchstart",
    (event) => {
      if (!isMobile()) return;
      const drawer = document.querySelector("facets-drawer");
      if (!drawer?.open) return;
      const touch = event.changedTouches[0];
      if (touch.clientX > 28) return;
      edgeStartX = touch.clientX;
      edgeStartY = touch.clientY;
      edgeTracking = true;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    (event) => {
      if (!edgeTracking) return;
      const drawer = document.querySelector("facets-drawer");
      if (!drawer?.open) {
        edgeTracking = false;
        return;
      }
      const touch = event.changedTouches[0];
      const dx = touch.clientX - edgeStartX;
      const dy = touch.clientY - edgeStartY;
      if (dx > 8 && Math.abs(dx) > Math.abs(dy)) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  document.addEventListener(
    "touchend",
    (event) => {
      if (!edgeTracking) return;
      edgeTracking = false;
      const drawer = document.querySelector("facets-drawer");
      if (!drawer?.open || typeof drawer.hide !== "function") return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - edgeStartX;
      const dy = touch.clientY - edgeStartY;
      if (dx > 50 && Math.abs(dy) < 50) {
        drawer.hide();
      }
    },
    { passive: true }
  );

  const watch = () => {
    document.querySelectorAll("facets-drawer").forEach(bindSwipe);
  };

  watch();
  document.addEventListener("facet:update", () => {
    window.setTimeout(watch, 50);
  });
})();
